// extracted by mini-css-extract-plugin
export default {"wrap":"pF-z","fullWidth":"qF-z","hideOnDesktop":"rF-z","content":"sF-z","hasOpenedNav":"tF-z","crumbsList":"uF-z","dropdownsWrap":"vF-z"};